import reducer from "./reducer";
export { default as templatesReducerName } from "./constants";
export default reducer;
